module.exports = __webpack_public_path__ + "img/icon_partner_search@2x.ebfcee8b.png";